document.addEventListener('DOMContentLoaded', function () {
  const stars = document.querySelectorAll('#fldev-star-rating .fldev-star');
  
  stars.forEach(star => {
    star.addEventListener('mouseover', () => {
      resetStars();
      highlightStars(star);
    });

    star.addEventListener('mouseout', resetStars);

    star.addEventListener('click', event => {
      const rating = star.getAttribute('data-value');
      if (rating >= 4) {
        window.open('https://fr.trustpilot.com/evaluate/rayondamour.com', '_blank');
      } else {
        window.location.href = '/pages/note-contact';
      }
    });
  });

  function highlightStars(star) {
    while (star) {
      star.style.filter = 'grayscale(0)';
      star = star.previousElementSibling;
    }
  }

  function resetStars() {
    stars.forEach(s => s.style.filter = 'grayscale(100%)');
  }
});

